const SCOPE = /^[A-Za-z0-9_-]{16,64}$/;

export function parseUiCapabilities(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  if (raw.version !== 1 || !raw.capabilities || typeof raw.capabilities !== "object" || Array.isArray(raw.capabilities)) return null;
  const enabled = raw.capabilities.obihub_os;
  if (typeof enabled !== "boolean") return null;
  if (!enabled) return raw.workspace_scope === null ? { enabled: false, workspaceScope: null } : null;
  if (typeof raw.workspace_scope !== "string" || !SCOPE.test(raw.workspace_scope)) return null;
  return { enabled: true, workspaceScope: raw.workspace_scope };
}

export { SCOPE as UI_SCOPE_PATTERN };
